import React from 'react';
import { RosaElementEnum } from '../../../constants';
import * as I from '@/assets/svg/ergonomic_tools/rosa';

export const ROSA_ELEMENTS_ICONS: Record<string, JSX.Element> = {
	[RosaElementEnum.KNEES_NINETY]: <I.KneesNinety />,
	[RosaElementEnum.KNEES_LESS_THAN_NINETY]: <I.KnessLessNinety />,
	[RosaElementEnum.KNEES_MORE_THAN_NINETY]: <I.KnessMoreNinety />,
	[RosaElementEnum.NO_FOOT_CONTACT]: <I.NoFootContact />,
	[RosaElementEnum.NO_LEG_MOBILITY]: <I.NoLegMobility />,
	[RosaElementEnum.SPACE_BETWEEN_KNEE_SEAT]: <I.SpaceKneeSeat />,
	[RosaElementEnum.SPACE_LESS_THAN_EIGHT]: <I.SpaceLessEight />,
	[RosaElementEnum.SPACE_MORE_THAN_EIGHT]: <I.SpaceMoreEight />,
	[RosaElementEnum.SHOULDERS_RELAXED]: <I.ShoulderRelaxed />,
	[RosaElementEnum.SHOULDERS_SHRUGGED]: <I.ShoulderShrugged />,
	[RosaElementEnum.VERY_DAMAGED_SURFACE]: <I.VeryDamageSurface />,
	[RosaElementEnum.VERY_WIDE]: <I.VeryWide />,
	[RosaElementEnum.ADEQUATE_LUMBAR_SUPPORT]: <I.LumbarSupport />,
	[RosaElementEnum.NO_LUMBAR_SUPPORT]: <I.NoLumbarSupport />,
	[RosaElementEnum.BACKREST_FAR_BACK_FORWARD]: <I.BackrestForward />,
	[RosaElementEnum.NON_BACKREST_LUMBAR_SUPPORT]: <I.NonBackrestSupport />,
	[RosaElementEnum.HIGH_WORK_SURFACE]: <I.HighWorkSurface />,
	[RosaElementEnum.SCREEN_EYE_LEVEL]: <I.ScreenEyeLevel />,
	[RosaElementEnum.VERY_LOW]: <I.VeryLow />,
	[RosaElementEnum.VERY_HIGH]: <I.VeryHigh />,
	[RosaElementEnum.NECK_ROTATED]: <I.NeckRotate />,
	[RosaElementEnum.GLARE_ON_SCREEN]: <I.GlareScreen />,
	[RosaElementEnum.NO_DOCUMENT_HOLDERS]: <I.DocumentHolders />,
	[RosaElementEnum.HEADPHONES]: <I.Headphones />,
	[RosaElementEnum.TOO_FAR]: <I.TooFar />,
	[RosaElementEnum.HOLDING_WITH_NECK]: <I.HoldingPhone />,
	[RosaElementEnum.MOUSE_LINE_SHOULDER]: <I.MouseLineShoulder />,
	[RosaElementEnum.ARM_ABDUCTION]: <I.ArmAbduction />,
	[RosaElementEnum.MOUSE_KEYBOARD_DIFFERENT_SURFACES]: <I.MouseKeyboardSurfaces />,
	[RosaElementEnum.GRIPPER_GRIP_MOUSE]: <I.GripMouse />,
	[RosaElementEnum.WRIST_REST]: <I.WristRest />,
	[RosaElementEnum.WRISTS_STRAIGHT]: <I.WristsStraight />,
	[RosaElementEnum.WRISTS_EXTENDED]: <I.WritsExtended />,
	[RosaElementEnum.WRIST_DEVIATION]: <I.WristDeviation />,
	[RosaElementEnum.KEYBOARD_TOO_HIGH]: <I.KeyboardTooHigh />,
	[RosaElementEnum.OBJECTS_OVERHEAD]: <I.ObjectOverhead />
};
